import actionTypes from "action_types/tester_account/authentication_action_types";

function signIn(authenticationToken, rememberMe) {
  return {
    type: actionTypes.SIGN_IN,
    payload: {
      authenticationToken,
      rememberMe,
    },
  };
}

function autoSignIn() {
  return {
    type: actionTypes.AUTO_SIGN_IN,
  };
}

function signOut() {
  return {
    type: actionTypes.SIGN_OUT,
  };
}

const loginTokenChecked = () => ({ type: actionTypes.LOGIN_TOKEN_CHECKED });

export default {
  signIn,
  autoSignIn,
  signOut,
  loginTokenChecked,
};
